import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation, Outlet } from 'react-router-dom';
import { withTransaction } from '@elastic/apm-rum-react';
import { useSelector, useDispatch } from 'react-redux';
import { Box } from '@mui/material';
import Sidebar from '../../components/Sidebar/Sidebar';
import AppHeader from '../../components/AppHeader/AppHeader';
import useOrganization from '../../hooks/UseOrganization';
import { commonSlice } from '../../state/reducers/common';

const Layout = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { getPermission, organizationDetailsList } = useOrganization();
  const subadmin = useSelector((state) => state.common.subAdminBoolean);
  const organizationList = useSelector(
    (state) => state.common.organizationList
  );
  const [loading, setLoading] = useState(true);
  const [userInfo, setUserInfo] = useState({});
  const location = useLocation();

  useEffect(() => {
    organizationDetailsList().then((res) => {
      dispatch(commonSlice.actions.setOrganizationList(res?.data?.data));
    });
  }, []);

  useEffect(() => {
    getPermission().then((res) => {
      setUserInfo(res?.data);
      setLoading(false);
    });
  }, []);

  const handleNavigation = () => {
    if (loading) return;

    const isRootPath = location.pathname === '/';
    const isDashboardPath = location.pathname === '/dashboard';

    if (subadmin && (isRootPath || isDashboardPath)) {
      navigate('/application-setting');
    } else if (!subadmin && isRootPath) {
      navigate('/dashboard');
    }
  };

  useEffect(() => {
    handleNavigation();
  }, [subadmin, loading]);

  return (
    <Box display="flex">
      <AppHeader userInfo={userInfo} organizationList={organizationList} />
      <Sidebar userInfo={userInfo} />
      <Box
        sx={{
          height: '100vh',
          flexGrow: 1,
          overflowY: 'auto',
          overflowX: 'hidden',
          paddingTop: '64px',
        }}
      >
        <Outlet />
      </Box>
    </Box>
  );
};

export default withTransaction('Layout', 'component')(Layout);
